import { useCallback, useState } from "react";

import { Toast } from "@covertree/utils";

import {
  UploadResult,
  useUploadSequoiaMutation,
} from "@redux/restApi/sequoiaUpload";
import { SequoiaUploadForm } from "./form";

export interface FileUploadResult {
  fileName: string;
  result: UploadResult;
}

export function useUploadSequoiaFiles(resetForm: () => void) {
  const [isLoading, setIsLoading] = useState(false);
  const [uploadResult, setUploadResult] = useState<FileUploadResult>();

  const [uploadSequoia] = useUploadSequoiaMutation();

  const handleSubmit = useCallback(
    async (payload: SequoiaUploadForm) => {
      setIsLoading(true);

      const result = await uploadSequoia({ file: payload.files[0] });

      if (result?.error) {
        Toast.showError("Could not upload sequoia file");
      } else {
        Toast.showSuccess(
          `File uploaded successfully! (${payload.files[0].name})`
        );
        setUploadResult({
          fileName: payload.files[0].name,
          result: result.data,
        });
      }

      resetForm();
      setIsLoading(false);
    },
    [resetForm, uploadSequoia]
  );

  return { loading: isLoading, handleSubmit, uploadResult };
}
